(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["background-container"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const initBackgrounds = () => {
    const backgroundContainers = document.querySelectorAll('.background-container');
    
    backgroundContainers.forEach(container => {
      const backgroundId = container.dataset.backgroundId;
      const startSection = document.querySelector(`[data-background-start="${backgroundId}"]`);
      const endSection = document.querySelector(`[data-background-end="${backgroundId}"]`);
      
      // Get the background image URL from the computed style
      const bgImage = window.getComputedStyle(container).backgroundImage;
      const imageUrl = bgImage.replace(/url\(['"]?(.*?)['"]?\)/i, '$1');
      
      // Load the image to get its dimensions
      const img = new Image();
      img.src = imageUrl;
      
      img.onload = function() {
        const imageAspectRatio = this.height / this.width;
        
        if (startSection && endSection) {
          const updatePosition = () => {
            const startRect = startSection.getBoundingClientRect();
            const endRect = endSection.getBoundingClientRect();
            const viewportWidth = window.innerWidth;
            
            // Calculate the height based on viewport width and image aspect ratio
            const calculatedHeight = viewportWidth * imageAspectRatio;
            
            // Use the larger of: calculated height or section height difference
            const sectionHeight = endRect.bottom - startRect.top;
            const finalHeight = Math.max(calculatedHeight, sectionHeight);
            
            const topOffset = startRect.top + window.scrollY;
            
            // Update container style
            container.style.height = `${finalHeight}px`;
            container.style.top = `${topOffset}px`;
          };

          // Initial position set
          updatePosition();
          
          // Update on window resize and scroll
          window.addEventListener('resize', updatePosition);
          window.addEventListener('scroll', updatePosition);
        }
      };
    });
  };

  initBackgrounds();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer_journey_stepper"] && !window.DesignMode) return;
  try {
    
    const video_data = new Map([
        ["all-tools", [
        {
            "title": "Chart Pattern Tutorial",
            "url": "https://youtu.be/detru489As8",
            "divider_before": false,
        },
        {
            "title": "Harmonic Pattern Strategy",
            "url": "https://youtu.be/FPNd9u5t7E4",
            "divider_before": true,
        },
        {
            "title": "Price Action Suite Tutorial",
            "url": "https://youtu.be/jx6oXKq4SJs",
            "divider_before": true,
        },
        {
            "title": "ICT Silverbullet Strategy",
            "url": "https://youtu.be/M_ZXHYAt1y4",
            "divider_before": true,
        },
        {
            "title": "SMT/Divergence Tutorial",
            "url": "https://youtu.be/Hsy7lV44sZY",
            "divider_before": true,
        },
        {
            "title": "Swing Suite Tutorial",
            "url": "https://youtu.be/5AjJlIv9Jkw",
            "divider_before": true,
        },
        {
            "title": "Market Scanner Tutorial",
            "url": "https://youtu.be/5aFdfJ03LAE",
            "divider_before": true,
        },
        ]],
        ["ict-smc", [
        {
            "title": "Price Action Suite Tutorial",
            "url": "https://youtu.be/jx6oXKq4SJs",
            "divider_before": false,
        },
        {
            "title": "Swing Suite Tutorial",
            "url": "https://youtu.be/5AjJlIv9Jkw",
            "divider_before": true,
        },
        {
            "title": "ICT Silverbullet Strategy",
            "url": "https://youtu.be/M_ZXHYAt1y4",
            "divider_before": true,
        },
        ]],
        ["zigzag-smt", [
        {
            "title": "Swing Suite Tutorial",
            "url": "https://youtu.be/5AjJlIv9Jkw",
            "divider_before": true,
        },
        {
            "title": "SMT/Divergence Tutorial",
            "url": "https://youtu.be/Hsy7lV44sZY",
            "divider_before": true,
        },
        {
            "title": "Trend and Reversal Scanner Tutorial",
            "url": "https://www.youtube.com/watch?v=5aFdfJ03LAE&t=231s",
            "divider_before": true,
        },
        ]],
        ["harmonics", [
        {
            "title": "Chart Pattern Tutorial",
            "url": "https://youtu.be/detru489As8",
            "divider_before": false,
        },
        {
            "title": "Harmonic Pattern Scanner Tutorial",
            "url": "https://youtu.be/5aFdfJ03LAE",
            "divider_before": true,
        },
        {
            "title": "Harmonic Pattern Strategy",
            "url": "https://youtu.be/FPNd9u5t7E4",
            "divider_before": true,
        },
        ]],
        ["patterns", [
        {
            "title": "Chart Pattern Tutorial",
            "url": "https://youtu.be/detru489As8",
            "divider_before": false,
        },
        {
            "title": "Consolidation & Head and Shoulders Scanner Tutorial",
            "url": "https://www.youtube.com/watch?v=5aFdfJ03LAE&t=180s",
            "divider_before": true,
        },
        {
            "title": "Consolidation Pattern Strategy",
            "url": "https://youtu.be/G6hLvLq_HLg",
            "divider_before": true,
        },
        ]],
        ["trend-bars", [
        {
            "title": "Trend Bars Pro Tutorial",
            "url": "https://youtu.be/iRguXuxuZVQ",
            "divider_before": false,
        },
        ]]
    ]);

    var max_step = 0;

    // Function to set a cookie
    function setCookie(name, value, days) {
        var expires = "";
        if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    // Function to get a cookie
    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    // Function to get URL parameters
    function getUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }
        
    // Function to erase a cookie
    function eraseCookie(name) {   
        document.cookie = name + '=; Max-Age=-99999999;';  
    }

    // initialize the steppers
    document.addEventListener('DOMContentLoaded', function () {
        // set the bundle
        var bundle = getUrlParameter('bundle');
        if (bundle) {
        var bundleSelect = document.getElementById('bundle');
        if (bundleSelect) {
            bundleSelect.value = bundle;
        }
        }
        
        var steppers = document.querySelectorAll('.bs-stepper');
        steppers.forEach(function(stepperElement) {
        var stepper = new Stepper(stepperElement, {
            linear: false,
            animation: true
        });

        // Add custom event listeners to the step triggers and remove the previous triggers
        stepperElement.querySelectorAll('.step-trigger').forEach(function(triggerElement) {
            var newTriggerElement = triggerElement.cloneNode(true);
            triggerElement.parentNode.replaceChild(newTriggerElement, triggerElement); // Remove default listeners by replacing the element

            newTriggerElement.addEventListener('click', function (event) {
            event.preventDefault();
            var stepIndex = Array.from(stepperElement.querySelectorAll('.step-trigger')).indexOf(newTriggerElement);
            // Only go to step 2 or 3 and only if the first step was reached
            if (max_step > 0 && stepIndex > 0) {
                stepper.to(stepIndex + 1); // Move to the desired step
                scrollCurrentStepIntoView(stepperElement);
            }
            });
        });

        // after this -> process the cookies
        var lastStep = getCookie('last_step');
        var selectedFreeTrial = getCookie('selected_free_trial');
        
        if (lastStep && selectedFreeTrial) {
            max_step = parseInt(lastStep, 10);
            loadVideos(selectedFreeTrial);
            stepper.to(max_step + 1);
        } else {
            // If no selection, start from the first step
            stepper.to(1);
            eraseCookie('last_step');
            eraseCookie('selected_free_trial');
        }
        
        
        // Add event listener to the Join Discord button
        var joinDiscordBtn = document.getElementById('join-discord-btn');
        if (joinDiscordBtn) {
            joinDiscordBtn.addEventListener('click', function (event) {
            event.preventDefault();
            stepper.next();
            max_step = 2;
            setCookie('last_step', max_step, 14);
            scrollCurrentStepIntoView(stepperElement);
            setTimeout(function() {
                window.open(joinDiscordBtn.href, '_blank');
            }, 300); // Delay opening the new tab
            });
        }

        // Handle form submission
        var signupForm = document.getElementById('signup-form');
        if (signupForm) {
            signupForm.addEventListener('submit', function (event) {
            event.preventDefault();
            
            // Get form values
            var tvUsername = document.querySelector('#tradingview-username').value;
            var email = document.querySelector('#email').value;
            var bundle = document.querySelector('#bundle').value;

            // TESTING
            /*stepper.next();
            max_step = 1;
            setCookie('selected_free_trial', bundle, 14);
            setCookie('last_step', max_step, 14);
            scrollCurrentStepIntoView(stepperElement);
            loadVideos(bundle);*/

            // google tag
            if (window.dataLayer) {
                window.dataLayer.push({
                  'event': 'free_trial_sign_up_click',
                  'product_id': bundle,
                  'tv_username': tvUsername
                });
            }
            fetch('https://backend.trntrading.ai/api/free-trial-by-type',
            {
                method: "POST",
                headers: {
                'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                tv_username: tvUsername,
                email: email,
                free_trial_type: "all-tools",
                clicked_free_trial_type: bundle,
                }),
                cache: 'no-cache'
            }).then(function (response) {
                return response.json();
            }).then(function (res) {
                if (res.status == "OK") {
                  stepper.next();
                  max_step = 1;
                  setCookie('selected_free_trial', bundle, 14);
                  setCookie('last_step', max_step, 14);
                  scrollCurrentStepIntoView(stepperElement);
                  loadVideos(bundle);
                } else {
                  handleFormErrors(res.status);
                }
            }).catch (err => {
                console.error('Error:', err);
                displayAlert('An error occurred. Please try again later.');
            });
            });
        }

        // Scroll the current step into view
        stepperElement.addEventListener('shown.bs-stepper', function (event) {
            scrollCurrentStepIntoView(stepperElement);
        });
        });
    });

    // Function to scroll the current step into view
    function scrollCurrentStepIntoView(stepperElement) {
        var activeStep = stepperElement.querySelector('.step.active .step-trigger');
        if (activeStep) {
        activeStep.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
    };
        
    // Function to load videos based on the selected bundle
    function loadVideos(bundle) {
        var videoContainer = document.getElementById('video-content');
        var videoList = video_data.get(bundle) || [];
        videoContainer.innerHTML = ''; // Clear existing content

        videoList.forEach(function(video) {
        if (video.divider_before) {
            var divider = document.createElement('hr');
            videoContainer.appendChild(divider);
        }
        var videoDiv = document.createElement('div');
        videoDiv.classList.add('mb-4');
        videoDiv.innerHTML = `
            <h3>${video.title}</h3>
            <div class="my-embed-container youtube-player" data-video-url="${video.url}"></div>
        `;
        videoContainer.appendChild(videoDiv);
        });

        // load oEmbed YouTube videos
        document.querySelectorAll('.youtube-player').forEach(function(playerElement) {
        var videoUrl = playerElement.dataset.videoUrl;
        var videoId = getYouTubeVideoId(videoUrl);
        if (videoId) {
            fetch(`https://www.youtube.com/oembed?url=https://www.youtube.com/watch?v=${videoId}&format=json`)
            .then(response => response.json())
            .then(data => {
                playerElement.innerHTML = data.html;
                playerElement.querySelector('iframe').classList.add('embed-responsive-item');
            })
            .catch(error => console.error('Error fetching oEmbed data:', error));
        }
        });
    }

    // Extract YouTube video ID from URL
    function getYouTubeVideoId(url) {
        const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
        const matches = url.match(regex);
        return matches ? matches[1] : null;
    }
        
    // Function to handle form errors
    function handleFormErrors(status) {
        var errorMessage = '';
        switch (status) {
        case "INVALID_USERNAME":
            errorMessage = 'The TradingView username is invalid.';
            break;
        case "INVALID_EMAIL":
            errorMessage = 'The email address is invalid.';
            break;
        case "FREE_TRIAL_ALREADY_USED":
            errorMessage = 'You have already used a free trial.';
            break;
        case "HAS_SUBSCRIPTION":
            errorMessage = 'You already have a subscription or lifetime license.';
            break;
        default:
            errorMessage = 'An internal error occurred. Please try again later.';
        }
        if (errorMessage) {
        displayAlert(errorMessage);
        }
    }

    // Function to display alert
    function displayAlert(message) {
        var alertDiv = document.getElementById('signup-alert');
        alertDiv.innerHTML = message;
        alertDiv.classList.remove('d-none');
        alertDiv.classList.add('d-block');
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["disable-cart-items"]) return;
  try {
    
  window.addEventListener('DOMContentLoaded', (event) => {
    const quantityInputs= document.querySelectorAll('.cart-item__quantity-input'); 
    quantityInputs.forEach((quantityInput) => {
        quantityInput.setAttribute('disabled', true);
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-list"] && !window.DesignMode) return;
  try {
    
window.addEventListener('DOMContentLoaded', (event) => {
  const showMoreBtn = document.querySelector('.col-md-6 .btn.show-more');
  const showLessBtn = document.querySelector('.col-md-6 .btn.show-less');
  const table = showMoreBtn.closest('.col-md-6').querySelector('.bundle-compare-table');

  // Initially hide 'Show less' button
  showLessBtn.style.display = 'none'; 
  showLessBtn.style.opacity = '0'; 

   showMoreBtn.addEventListener('click', function () {
    table.classList.remove('collapsed');
    this.style.display = 'none';
    showLessBtn.style.display = 'block';
    setTimeout(() => { showLessBtn.style.opacity = '1'; }, 0);
    console.log('Show more clicked: table should expand');
  });

  showLessBtn.addEventListener('click', function () {
    table.classList.add('collapsed');
    this.style.display = 'none';
    showMoreBtn.style.display = 'block';
    setTimeout(() => { showMoreBtn.style.opacity = '1'; }, 0);
    console.log('Show less clicked: table should collapse');
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["free-trial"]) return;
  try {
    
  var my_free_trial_type = null;
  var test_all_tools = false;
  
  const free_trials = new Map([
    ["all-tools", {"name" : "TRN Suite", "fwd": "https://trntrading.ai/pages/welcome-to-our-free-trial"}],    
    ["ict-smc", {"name" : "ICT & Smart Money Concepts", "fwd": "https://trntrading.ai/pages/welcome-to-our-free-trial-ict-smc"}],
    ["zigzag-smt", {"name" : "ZigZag & SMT/Divergences", "fwd": "https://trntrading.ai/pages/welcome-to-our-free-trial-smt-divergence-swings"}],    
    ["harmonics", {"name" : "Harmonic Patterns", "fwd": "https://trntrading.ai/pages/welcome-to-our-free-trial-harmonics"}],
    ["patterns", {"name" : "Classic Chart Patterns", "fwd": "https://trntrading.ai/pages/welcome-to-our-free-trial-classic-patterns"}],    
    ["trend-bars", {"name" : "Trend Bars Pro", "fwd": "https://trntrading.ai/pages/copy-of-welcome-to-our-free-trend-bars-pro"}]
  ]);
  
  function closeMobileNav() {
    if ($("body").hasClass("enable-mobile-nav-transition")) {
      $("body").removeClass("reveal-mobile-nav reveal-mobile-nav--revealed");
      setTimeout(function() {
        $("body").removeClass("enable-mobile-nav-transition");
      }, 750); // Assuming this delay is for a closing animation
    }
  }
  
  function show_free_trial_modal(free_trial_type) {
    my_free_trial_type = free_trial_type;
    test_all_tools = false;
    document.querySelector('#free-trial-modal').classList.add("active");
    document.querySelector('#free-trial-header').innerHTML= free_trials.get(my_free_trial_type).name + "<br>7 Days Free Trial";
    if (free_trial_type == "all-tools") {
        // hide the test all tools checkbox
        document.querySelector('#free-trial-test-all-tools-field').style.display = 'none';
    } else {
        document.querySelector('#free-trial-test-all-tools-field').style.display = 'block';      
    }
  }

  function hide_free_trial_modal() {
    my_free_trial_type = null;
    test_all_tools = false;
    document.querySelector('#free-trial-modal').classList.remove("active");
    document.querySelector('#free-trial-alert-general-error').classList.remove('show');
  }

  // Function to handle the addition of new trial buttons or changes to existing ones
  function handleTrialButtons() {
    const trialBtns = document.querySelectorAll('a[href*="#free-trial-now"]');
    trialBtns.forEach((trialBtn) => {
      // Ensure we don't add multiple listeners to the same button
      if (!trialBtn.classList.contains('js-free-trial-all-tools-processed')) {
        trialBtn.classList.add('js-free-trial-all-tools-processed');
        trialBtn.addEventListener('click', function (e) {
            e.preventDefault();
            closeMobileNav();
            show_free_trial_modal("all-tools");
        });
      }
    });

    const ictTrialBtns = document.querySelectorAll('a[href*="#ict-smc-free-trial"]');
    ictTrialBtns.forEach((trialBtn) => {
      // Ensure we don't add multiple listeners to the same button
      if (!trialBtn.classList.contains('js-free-trial-ict-smc-processed')) {
        trialBtn.classList.add('js-free-trial-ict-smc-processed');
        trialBtn.addEventListener('click', function (e) {
            e.preventDefault();
            closeMobileNav();
            show_free_trial_modal("ict-smc");
        });
      }
    });

    const zigTrialBtns = document.querySelectorAll('a[href*="#zigzag-smt-free-trial"]');
    zigTrialBtns.forEach((trialBtn) => {
      // Ensure we don't add multiple listeners to the same button
      if (!trialBtn.classList.contains('js-free-trial-zigzag-smt-processed')) {
        trialBtn.classList.add('js-free-trial-zigzag-smt-processed');
        trialBtn.addEventListener('click', function (e) {
            e.preventDefault();
            closeMobileNav();
            show_free_trial_modal("zigzag-smt");
        });
      }
    });

    const harTrialBtns = document.querySelectorAll('a[href*="#harmonics-free-trial"]');
    harTrialBtns.forEach((trialBtn) => {
      // Ensure we don't add multiple listeners to the same button
      if (!trialBtn.classList.contains('js-free-trial-harmonics-processed')) {
        trialBtn.classList.add('js-free-trial-harmonics-processed');
        trialBtn.addEventListener('click', function (e) {
            e.preventDefault();
            closeMobileNav();
            show_free_trial_modal("harmonics");
        });
      }
    });

    const patTrialBtns = document.querySelectorAll('a[href*="#patterns-free-trial"]');
    patTrialBtns.forEach((trialBtn) => {
      // Ensure we don't add multiple listeners to the same button
      if (!trialBtn.classList.contains('js-free-trial-patterns-processed')) {
        trialBtn.classList.add('js-free-trial-patterns-processed');
        trialBtn.addEventListener('click', function (e) {
            e.preventDefault();
            closeMobileNav();
            show_free_trial_modal("patterns");
        });
      }
    });
    
    const trndTrialBtns = document.querySelectorAll('a[href*="#trend-bars-free-trial"]');
    trndTrialBtns.forEach((trialBtn) => {
      // Ensure we don't add multiple listeners to the same button
      if (!trialBtn.classList.contains('js-free-trial-trend-bars-processed')) {
        trialBtn.classList.add('js-free-trial-trend-bars-processed');
        trialBtn.addEventListener('click', function (e) {
            e.preventDefault();
            closeMobileNav();
            show_free_trial_modal("trend-bars");
        });
      }
    });
  }
  
  // Initial handling in case the elements are already present
  handleTrialButtons();
  
  // Setting up the MutationObserver
  const observer = new MutationObserver((mutationsList, observer) => {
    // For each mutation record, check if the added nodes contain our target elements
    for(const mutation of mutationsList) {
      if (mutation.type === 'childList' && mutation.addedNodes.length) {
        // New nodes have been added, handle the trial buttons again
        handleTrialButtons();
      }
    }
  });

  // Configuration object for the observer (what mutations to observe)
  const config = { childList: true, subtree: true };
  
  // Start observing the document body for DOM changes
  observer.observe(document.body, config);

  window.addEventListener('DOMContentLoaded', (event) => {
    
      document.querySelector('#free-trial-modal-close').addEventListener('click', function () {
          hide_free_trial_modal();
      });

      const submitButton = document.querySelector('#submitFreeTrialButton');
      submitButton.addEventListener('click', function (e) {
          document.querySelector('#free-trial-alert-general-error').classList.remove('show');
          document.querySelector('#free-trial-input-email').classList.add('checked');
          document.querySelector('#free-trial-input-tv').classList.add('checked');
          document.querySelector('#free-trial-newsletter-check').classList.add('checked');
          if (document.querySelector('#free-trial-newsletter-check').checked) {
                  submitButton.disabled = true;
                  fetch('https://backend.trntrading.ai/api/free-trial-by-type',
                  {
                      method: "POST",
                      headers: {
                          'Content-Type': 'application/json'
                      },
                      body: JSON.stringify({
                          tv_username: document.querySelector('#free-trial-input-tv').value,
                          email: document.querySelector('#free-trial-input-email').value,
                          free_trial_type: test_all_tools? "all-tools" : my_free_trial_type,
                          clicked_free_trial_type: my_free_trial_type
                      }),
                      cache: 'no-cache'
                  }).then(function (response) {
                      response.json().then(res => {
                          if (res.status == "OK") {
                              submitButton.innerHTML = "Successfully registered";
                              window.location.assign(free_trials.get(my_free_trial_type).fwd);
                              submitButton.disabled = false;
                          } else {
                              submitButton.disabled = false;
                              if (res.status == "INVALID_USERNAME") {
                                  document.querySelector('#free-trial-input-tv').classList.add('invalid');                        
                                  document.querySelector('#free-trial-tv-name-error-message').innerHTML = "Enter the username from your TradingView profile.<br>In case you do not have a TradingView account,<br>please sign up for TradingView first <a href=\"https://www.tradingview.com/gopro/?share_your_love=TRN-Trading\" target=\"_blank\">here</a>.";
                              } else if (res.status == "INVALID_EMAIL") {
                                  document.querySelector('#free-trial-input-email').classList.add('invalid');                        
                                  document.querySelector('#free-trial-email-error-message').innerHTML = "Invalid e-mail address";
                              } else if (res.status == "FREE_TRIAL_ALREADY_USED") {                   
                                  document.querySelector('#free-trial-alert-general-error').innerHTML = "You have already used the free-trial.";
                                  document.querySelector('#free-trial-alert-general-error').classList.add('show');
                              } else if (res.status == "HAS_SUBSCRIPTION") {                   
                                  document.querySelector('#free-trial-alert-general-error').innerHTML = "You have already have a subscription.";
                                  document.querySelector('#free-trial-alert-general-error').classList.add('show');                              
                              } else {
                                  document.querySelector('#free-trial-alert-general-error').innerHTML = "Unknown internal error occurred. Please try again later.";  
                                  document.querySelector('#free-trial-alert-general-error').classList.add('show');                              
                              }
                          }
                      }).catch (err => {
                          document.querySelector('#free-trial-alert-general-error').innerHTML = "Unknown internal error occurred. Please try again later.";  
                          document.querySelector('#free-trial-alert-general-error').classList.add('show');
                          submitButton.disabled = false;
                      });
                  }).catch (err => {
                      document.querySelector('#free-trial-alert-general-error').innerHTML = "Unknown internal error occurred. Please try again later.";  
                      document.querySelector('#free-trial-alert-general-error').classList.add('show');
                  });
          } else {
              document.querySelector('#free-trial-newsletter-check').classList.add('invalid');                        
              document.querySelector('#free-trial-email-checkbox-error-message').innerHTML = "Required";
          }
      });

      document.querySelector('#free-trial-input-tv').addEventListener('blur', function() {
          // clear everything
          document.querySelector('#free-trial-tv-name-error-message').innerHTML="";
          document.querySelector('#free-trial-input-tv').classList.remove('valid')
          document.querySelector('#free-trial-input-tv').classList.remove('invalid')
      })

      document.querySelector('#free-trial-input-email').addEventListener('blur', function() {
          // clear everything
          document.querySelector('#free-trial-email-error-message').innerHTML="";
          document.querySelector('#free-trial-input-email').classList.remove('valid')
          document.querySelector('#free-trial-input-email').classList.remove('invalid')
      })

      document.querySelector('#free-trial-newsletter-check').addEventListener('change', function() {
          // clear everything
          if (document.querySelector('#free-trial-newsletter-check').checked) {
              document.querySelector('#free-trial-email-checkbox-error-message').innerHTML="";           
          } else {
              document.querySelector('#free-trial-email-checkbox-error-message').innerHTML="Required";       
          }
      })
    
      document.querySelector('#free-trial-test-all-tools').addEventListener('change', function() {
        if (document.querySelector('#free-trial-test-all-tools').checked) {
          test_all_tools = true;
          // load the new name
          document.querySelector('#free-trial-header').innerHTML= free_trials.get("all-tools").name + "<br>7 Days Free Trial";
          
        } else {
          test_all_tools = false;
          // load the old name          
          document.querySelector('#free-trial-header').innerHTML= free_trials.get(my_free_trial_type).name + "<br>7 Days Free Trial";
        }
      })
  });
      

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    /*const imgList = document.querySelectorAll(".rimage-wrapper");
    for (let i = 0; i < imgList.length; i++) {
      imgList[i].addEventListener("mousemove", function(e) {
        var x = (e.clientX - getOffset(imgList[i]).left) /1;
        var y = (e.clientY - getOffset(imgList[i]).top) /1;
        var coor = "Coordinates: (" + x + "," + y + ")";
        console.log(coor);
        imgList[i].querySelector('img').style.marginLeft=-x+'px';
        imgList[i].querySelector('img').style.marginTop=-y+'px';
      });
      imgList[i].addEventListener("mouseleave", function(e) {
        imgList[i].querySelector('img').style.marginLeft=0+'px';
        imgList[i].querySelector('img').style.marginTop=0+'px';
      });
    }*/
    window.setTimeout(flyIn,500);
  });

  document.addEventListener("scroll", (event) => {
    flyIn();
  });

  function flyIn(){   
    const flyObjectList = document.querySelectorAll(".fly");
    for (let i = 0; i < flyObjectList.length; i++) {
      if(isScrolledIntoView(flyObjectList[i])){
        window.setTimeout(function(){flyObjectList[i].classList.add('fly-visible');}, ((i-1)*200));
      } else {
        /*window.setTimeout(function(){flyObjectList[i].classList.remove('fly-visible');}, ((i-1)*200));*/
      }
    }
  }
  function getOffset(el) {
    const rect = el.getBoundingClientRect();
    return {
      left: rect.left,
      top: rect.top
    };
  }
  function isScrolledIntoView(el) {
    var rect = el.getBoundingClientRect();
    var elemTop = rect.top;
    var elemBottom = rect.bottom;
    var isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
    return isVisible;
  }
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lifetime"]) return;
  try {
    
  
  function show_free_trial_modal() {
    document.querySelector('#lifetime-modal').classList.add("active");
  }

  function hide_free_trial_modal() {
    document.querySelector('#lifetime-modal').classList.remove("active");
    document.querySelector('#lifetime-alert-general-error').classList.remove('show');
  }

  // Function to handle the addition of new trial buttons or changes to existing ones
  function handleTrialButtons() {
    const trialBtns = document.querySelectorAll('a[href*="buy-lifetime"]');
    trialBtns.forEach((trialBtn) => {
      // Ensure we don't add multiple listeners to the same button
      if (!trialBtn.classList.contains('js-lifetime-processed')) {
        trialBtn.classList.add('js-lifetime-processed');
        trialBtn.addEventListener('click', function (e) {
            e.preventDefault();
            show_free_trial_modal();
        });
      }
    });
  }
  
  // Initial handling in case the elements are already present
  handleTrialButtons();
  
  // Setting up the MutationObserver
  const observer = new MutationObserver((mutationsList, observer) => {
    // For each mutation record, check if the added nodes contain our target elements
    for(const mutation of mutationsList) {
      if (mutation.type === 'childList' && mutation.addedNodes.length) {
        // New nodes have been added, handle the trial buttons again
        handleTrialButtons();
      }
    }
  });
  
  // Configuration object for the observer (what mutations to observe)
  const config = { childList: true, subtree: true };
  
  // Start observing the document body for DOM changes
  observer.observe(document.body, config);

  window.addEventListener('DOMContentLoaded', (event) => {
    
      document.querySelector('#lifetime-modal-close').addEventListener('click', function () {
          hide_free_trial_modal();
      });

      const submitButton = document.querySelector('#submitLifetime');
      submitButton.addEventListener('click', function (e) {
          document.querySelector('#lifetime-alert-general-error').classList.remove('show');
          document.querySelector('#lifetime-input-tv').classList.add('checked');
          submitButton.disabled = true;
        fetch('https://backend.trntrading.ai/api/check-tv-username',
          {
              method: "POST",
              headers: {
                  'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                  tv_username: document.querySelector('#lifetime-input-tv').value
              }),
              cache: 'no-cache'
          }).then(function (response) {
              response.json().then(res => {
                  if (res.status == "OK") {
                      submitButton.innerHTML = "Redirecting";
                      const encodedUsername = encodeURIComponent(res.username);
                      replaced_str = "https://trntrading.ai/cart/48934367625549:1?attributes[tv_username]={tv_username}".replace("{tv_username}", encodedUsername)
                      window.location.assign(replaced_str); // just replacing
                      submitButton.disabled = false;
                  } else {
                      submitButton.disabled = false;
                      if (res.status == "INVALID_USERNAME") {
                          document.querySelector('#lifetime-input-tv').classList.add('invalid');                        
                          document.querySelector('#lifetime-tv-name-error-message').innerHTML = "Enter the username from your TradingView profile.<br>In case you do not have a TradingView account,<br>please sign up for TradingView first <a href=\"https://www.tradingview.com/gopro/?share_your_love=TRN-Trading\" target=\"_blank\">here</a>.";
                      } else {                   
                          document.querySelector('#lifetime-tv-name-error-message').innerHTML = "An internal error occurred. Please try again later.";                          
                      }
                  }
              }).catch (err => {
                  document.querySelector('#lifetime-alert-general-error').classList.add('show');
                  submitButton.disabled = false;
              });
          }).catch (err => {
              document.querySelector('#lifetime-alert-general-error').classList.add('show');
          });
      });

      document.querySelector('#lifetime-input-tv').addEventListener('blur', function() {
          // clear everything
          document.querySelector('#lifetime-tv-name-error-message').innerHTML="";
          document.querySelector('#lifetime-input-tv').classList.remove('valid')
          document.querySelector('#lifetime-input-tv').classList.remove('invalid')
      })
  });
      

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-customer-journey"] && !window.DesignMode) return;
  try {
    
    const video_data = new Map([
        ["essential", [        
        {
            "title": "Trend Bars Pro Tutorial",
            "url": "https://youtu.be/aWOndpHzKpc",
            "divider_before": false,
        },
        {
            "title": "Trend and Reversal Scanner Tutorial",
            "url": "https://www.youtube.com/watch?v=5aFdfJ03LAE&t=231s",
            "divider_before": true,
        },
        ]],
        ["pro", [
        {
            "title": "Trend Bars Pro Tutorial",
            "url": "https://youtu.be/aWOndpHzKpc",
            "divider_before": false,
        }, 
        {
            "title": "Price Action Suite Tutorial",
            "url": "https://youtu.be/jx6oXKq4SJs",
            "divider_before": true,
        },
        {
            "title": "SMT Divergence Suite Tutorial + Strategy",
            "url": "https://youtu.be/Hsy7lV44sZY",
            "divider_before": true,
        },
        {
            "title": "Swing Suite Tutorial",
            "url": "https://youtu.be/5AjJlIv9Jkw",
            "divider_before": true,
        },
        {
            "title": "ICT Silverbullet Strategy",
            "url": "https://youtu.be/M_ZXHYAt1y4",
            "divider_before": true,
        },
        {
            "title": "Trend and Reversal Scanner Tutorial",
            "url": "https://www.youtube.com/watch?v=5aFdfJ03LAE&t=231s",
            "divider_before": true,
        },
        ]],
        ["chart-pattern-suite", [
        {
            "title": "Chart Pattern Tutorial",
            "url": "https://youtu.be/detru489As8",
            "divider_before": false,
        },
        {
            "title": "Harmonic Pattern Scanner Tutorial",
            "url": "https://youtu.be/5aFdfJ03LAE",
            "divider_before": true,
        },
        {
            "title": "Harmonic Pattern Strategy",
            "url": "https://youtu.be/FPNd9u5t7E4",
            "divider_before": true,
        },
        {
            "title": "Consolidation Pattern Strategy",
            "url": "https://youtu.be/G6hLvLq_HLg",
            "divider_before": true,
        },
        {
            "title": "Consolidation & Head and Shoulders Scanner Tutorial",
            "url": "https://www.youtube.com/watch?v=5aFdfJ03LAE&t=180s",
            "divider_before": true,
        },
        ]]
    ]);

    var max_step = 0;

    // Function to set a cookie
    function setCookie(name, value, days) {
        var expires = "";
        if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    // Function to get a cookie
    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }

    // Function to get URL parameters
    function getUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }
        
    // Function to erase a cookie
    function eraseCookie(name) {   
        document.cookie = name + '=; Max-Age=-99999999;';  
    }

    // initialize the steppers
    document.addEventListener('DOMContentLoaded', function () {
        // set the bundle and load the videos
        var bundle = getUrlParameter('bundle');
        if (bundle) {
            loadVideos(bundle);
        }
        
        var steppers = document.querySelectorAll('.bs-stepper');
        steppers.forEach(function(stepperElement) {
        var stepper = new Stepper(stepperElement, {
            linear: false,
            animation: true
        });

        // Add custom event listeners to the step triggers and remove the previous triggers
        stepperElement.querySelectorAll('.step-trigger').forEach(function(triggerElement) {
            var newTriggerElement = triggerElement.cloneNode(true);
            triggerElement.parentNode.replaceChild(newTriggerElement, triggerElement); // Remove default listeners by replacing the element

            newTriggerElement.addEventListener('click', function (event) {
            event.preventDefault();
            var stepIndex = Array.from(stepperElement.querySelectorAll('.step-trigger')).indexOf(newTriggerElement);
            // Only go to step 2 or 3 and only if the first step was reached
            if (max_step > 0 && stepIndex > 0) {
                stepper.to(stepIndex + 1); // Move to the desired step
                scrollCurrentStepIntoView(stepperElement);
            }
            });
        });

        // after this -> process the cookies
        var lastStep = getCookie('new_journey_last_step');
        var selectedBundle = getCookie('new_journey_selected_bundle');
        
        if (lastStep && selectedBundle) {
            max_step = parseInt(lastStep, 10);
            loadVideos(selectedBundle);
            stepper.to(max_step + 1);
        } else {
            // If no selection, start from the first step
            stepper.to(1);
            eraseCookie('new_journey_last_step');
            eraseCookie('new_journey_selected_bundle');
        }
        
        
        // Add event listener to the Join Discord button
        var joinDiscordBtns = document.getElementsByClassName('discord-btn-trigger');
        if (joinDiscordBtns.length > 0) {
            Array.from(joinDiscordBtns).forEach(function(joinDiscordBtn) {
                joinDiscordBtn.addEventListener('click', function (event) {
                    event.preventDefault();
                    stepper.next();
                    max_step = 1;
                    setCookie('new_journey_last_step', max_step, 14);
                    scrollCurrentStepIntoView(stepperElement);
                    if (joinDiscordBtn.href) {
                        setTimeout(function() {
                            window.open(joinDiscordBtn.href, '_blank');
                        }, 300); // Delay opening the new tab
                    }
                });
            });
        }

        // Scroll the current step into view
        stepperElement.addEventListener('shown.bs-stepper', function (event) {
            scrollCurrentStepIntoView(stepperElement);
        });
        });
    });

    // Function to scroll the current step into view
    function scrollCurrentStepIntoView(stepperElement) {
        var activeStep = stepperElement.querySelector('.step.active .step-trigger');
        if (activeStep) {
        activeStep.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
    };
        
    // Function to load videos based on the selected bundle
    function loadVideos(bundle) {
        var videoContainer = document.getElementById('video-content');
        var videoList = video_data.get(bundle) || [];
        videoContainer.innerHTML = ''; // Clear existing content

        videoList.forEach(function(video) {
        if (video.divider_before) {
            var divider = document.createElement('hr');
            videoContainer.appendChild(divider);
        }
        var videoDiv = document.createElement('div');
        videoDiv.classList.add('mb-4');
        videoDiv.innerHTML = `
            <h3>${video.title}</h3>
            <div class="my-embed-container youtube-player" data-video-url="${video.url}"></div>
        `;
        videoContainer.appendChild(videoDiv);
        });

        // load oEmbed YouTube videos
        document.querySelectorAll('.youtube-player').forEach(function(playerElement) {
        var videoUrl = playerElement.dataset.videoUrl;
        var videoId = getYouTubeVideoId(videoUrl);
        if (videoId) {
            fetch(`https://www.youtube.com/oembed?url=https://www.youtube.com/watch?v=${videoId}&format=json`)
            .then(response => response.json())
            .then(data => {
                playerElement.innerHTML = data.html;
                playerElement.querySelector('iframe').classList.add('embed-responsive-item');
            })
            .catch(error => console.error('Error fetching oEmbed data:', error));
        }
        });
    }

    // Extract YouTube video ID from URL
    function getYouTubeVideoId(url) {
        const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
        const matches = url.match(regex);
        return matches ? matches[1] : null;
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-pricing-table-simple"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
  
    document.querySelectorAll('.tt-simple-pricing-table .buy-button').forEach((button) => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        const card = this.closest('.card');
        const inputContainer = card.querySelector('.username-input-container');
        const input = card.querySelector('.username-input');
        const invalidFeedback = card.querySelector('.invalid-feedback');
        const productId = this.getAttribute('data-product-id');
        const currentPlan = this.getAttribute('data-plan');
  
        if (inputContainer.style.display === 'none') {
          // google tag manager
          if (window.dataLayer) {
            window.dataLayer.push({
              'event': 'buy_button_click',
              'product_id': productId,
              'plan_type': currentPlan
            });
          }
          inputContainer.style.display = 'block';
          this.textContent = 'Proceed to Checkout';
        } else {
          const username = input.value.trim();
          if (username) {          
            // google tag manager
            if (window.dataLayer) {
              window.dataLayer.push({
                'event': 'to_checkout_click',
                'product_id': productId,
                'plan_type': currentPlan,
                'tv_username': username
              });
            }
            // Validate username and proceed to checkout
            validateUsername(username).then(res => {
              if (res.valid) {
                const link = this.getAttribute('data-link');
                proceedToCheckout(res.username, link);
              } else {
                input.classList.add('is-invalid');
                invalidFeedback.textContent = res.error;
                invalidFeedback.style.display = 'block';
              }
            });
          } else {
            input.classList.add('is-invalid');
            invalidFeedback.textContent = 'Please enter a TradingView username.';
            invalidFeedback.style.display = 'block';
          }
        }
      });
    });
  
    document.querySelectorAll('.tt-simple-pricing-table .username-input').forEach((input) => {
      input.addEventListener('input', function() {
        this.classList.remove('is-invalid');
        this.closest('.card').querySelector('.invalid-feedback').style.display = 'none';
      });
    });
  
    function validateUsername(username) {
      return fetch('https://api.trntrading.ai/shopify/check-tv-username', {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          tv_username: username
        }),
        cache: 'no-cache'
      })
      .then(response => response.json())
      .then(res => {
        if (res.status == "OK") {
          return {
            valid: true,
            username: res.username,
            error: null
          };
        } else if (res.status == "INVALID_USERNAME") {
          return {
            valid: false,
            username: null,
            error: "Please enter a valid TradingView username."
          };
        } else {                   
          return {
            valid: false,
            username: null,
            error: "An internal error occurred. Please try again later."
          };
        }
      })
      .catch(err => {
        return {
          valid: false,
          username: null,
          error: "An internal error occurred. Please try again later."
        };
      });
    }
  
    function proceedToCheckout(username, link) {
      const checkoutUrl = link.replace("{tv_username}", username)
      window.location.assign(checkoutUrl);
    }
  });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-pricing-table"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {

  // First define all the elements and functions we'll need
  const monthlySelect = document.getElementById('monthly-select');
  const yearlySelect = document.getElementById('yearly-select');
  const lifetimeSelect = document.getElementById('lifetime-select');
  const yearlyButton = document.getElementById('yearly-button');
  const yearlyPopOver = new bootstrap.Popover(yearlyButton, {
    trigger: 'manual'
  });

  function updateVisibility(showClass) {
    document.querySelectorAll('.monthly-price, .yearly-price, .lifetime-price').forEach(el => el.classList.add('invisible'));
    document.querySelectorAll('.' + showClass).forEach(el => el.classList.remove('invisible'));
    
    document.querySelectorAll('.buy-button').forEach((button) => {
      const planType = showClass.split('-')[0];
      button.setAttribute('data-current-link', button.getAttribute('data-link-' + planType));
      button.textContent = button.getAttribute('data-text-' + planType);
    });
  }

  // Set up event listeners for price switching
  monthlySelect.addEventListener('click', () => {
    updateVisibility('monthly-price');
  });
  
  yearlySelect.addEventListener('click', () => {
    updateVisibility('yearly-price');
  });
  
  lifetimeSelect.addEventListener('click', () => {
    updateVisibility('lifetime-price');
  });

  yearlyPopOver.show();
  updateVisibility('yearly-price'); // Set default selection to yearly

  document.querySelectorAll('.free-trial-button').forEach((button) => {
    button.addEventListener('click', function(e) {
      const productId = this.getAttribute('data-product-id');
            
      // Push the custom event to the data layer
      if (window.dataLayer) {
        window.dataLayer.push({
          'event': 'free_trial_pricing_table_click',
          'product_id': productId
        });
      }
    });
  });

  document.querySelectorAll('.buy-button').forEach((button) => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      const card = this.closest('.card');
      const inputContainer = card.querySelector('.username-input-container');
      const input = card.querySelector('.username-input');
      const invalidFeedback = card.querySelector('.invalid-feedback');
      const productId = this.getAttribute('data-product-id');
      const currentPlan = document.querySelector('input[name="btnradio"]:checked').id.split('-')[0];

      if (inputContainer.style.display === 'none') {
        // google tag manager
        if (window.dataLayer) {
          window.dataLayer.push({
            'event': 'buy_button_click',
            'product_id': productId,
            'plan_type': currentPlan
          });
        }
        inputContainer.style.display = 'block';
        this.textContent = 'Proceed to Checkout';
      } else {
        const username = input.value.trim();
        if (username) {          
          // google tag manager
          if (window.dataLayer) {
            window.dataLayer.push({
              'event': 'to_checkout_click',
              'product_id': productId,
              'plan_type': currentPlan,
              'tv_username': username
            });
          }
          // Validate username and proceed to checkout
          validateUsername(username).then(res => {
            if (res.valid) {
              const link = this.getAttribute('data-current-link');
              proceedToCheckout(res.username, link);
            } else {
              input.classList.add('is-invalid');
              invalidFeedback.textContent = res.error;
              invalidFeedback.style.display = 'block';
            }
          });
        } else {
          input.classList.add('is-invalid');
          invalidFeedback.textContent = 'Please enter a TradingView username.';
          invalidFeedback.style.display = 'block';
        }
      }
    });
  });

  document.querySelectorAll('.username-input').forEach((input) => {
    input.addEventListener('input', function() {
      this.classList.remove('is-invalid');
      this.closest('.card').querySelector('.invalid-feedback').style.display = 'none';
    });
  });

  function validateUsername(username) {
    return fetch('https://api.trntrading.ai/shopify/check-tv-username', {
      method: "POST",
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        tv_username: username
      }),
      cache: 'no-cache'
    })
    .then(response => response.json())
    .then(res => {
      if (res.status == "OK") {
        return {
          valid: true,
          username: res.username,
          error: null
        };
      } else if (res.status == "INVALID_USERNAME") {
        return {
          valid: false,
          username: null,
          error: "Please enter a valid TradingView username."
        };
      } else {                   
        return {
          valid: false,
          username: null,
          error: "An internal error occurred. Please try again later."
        };
      }
    })
    .catch(err => {
      return {
        valid: false,
        username: null,
        error: "An internal error occurred. Please try again later."
      };
    });
  }

  function proceedToCheckout(username, link) {
    const checkoutUrl = link.replace("{tv_username}", username)
    window.location.assign(checkoutUrl);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-content-carousel3"] && !window.DesignMode) return;
  try {
      
  document.addEventListener('DOMContentLoaded', function () {
      const carousel = document.querySelector('.product-content-carousel3 .scrollable-carousel');
      const prevButton = document.querySelector('.product-content-carousel3 .carousel-control-prev');
      const nextButton = document.querySelector('.product-content-carousel3 .carousel-control-next');

      // scrolling button show / remove
      function updateButtonVisibility() {
          const scrollLeft = carousel.scrollLeft;
          const maxScrollLeft = carousel.scrollWidth - carousel.clientWidth;  
          // Hide prev button if at start, otherwise show it
          prevButton.style.display = scrollLeft > 0 ? '' : 'none';  
          // Hide next button if at end, otherwise show it
          nextButton.style.display = scrollLeft < maxScrollLeft ? '' : 'none';
      }
      updateButtonVisibility();
      carousel.addEventListener('scroll', updateButtonVisibility);

      // scrolling button handling
      function getScrollDistance() {
          const card = carousel.querySelector('.card');
          const style = card.currentStyle || window.getComputedStyle(card);
          const cardMargin = parseFloat(style.marginRight);
          return card.offsetWidth + cardMargin;
      }  
      prevButton.addEventListener('click', function () {
          carousel.scrollBy({ left: -getScrollDistance(), behavior: 'smooth' }); // Adjust scroll amount as needed
      });
      nextButton.addEventListener('click', function () {
          console.log("scrolling: " + getScrollDistance())
          carousel.scrollBy({ left: getScrollDistance(), behavior: 'smooth' }); // Adjust scroll amount as needed
      });
  
      // swipe gesture
      let startX, moveX, isTouching = false;
      function onTouchStart(e) {
        isTouching = true;
        startX = e.touches[0].clientX;
      }
      function onTouchMove(e) {
        if (!isTouching) return;
        moveX = e.touches[0].clientX;
        let moveDistance = moveX - startX;
        carousel.scrollLeft -= moveDistance;    
        startX = moveX; // Reset startX for the next onTouchMove call
      }
      function onTouchEnd() {
        isTouching = false;
      }
      carousel.addEventListener('touchstart', onTouchStart);
      carousel.addEventListener('touchmove', onTouchMove);
      carousel.addEventListener('touchend', onTouchEnd);

      // debug stuff
      /*document.querySelectorAll('*').forEach(el => {
        if(el.offsetWidth > document.documentElement.clientWidth) {
          console.log('Overflowing element:', el);
        }
      });*/
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-content"] && !window.DesignMode) return;
  try {
      
  document.addEventListener('DOMContentLoaded', function () {
      const carousel = document.querySelector('.product-content .scrollable-carousel');
      const prevButton = document.querySelector('.product-content .carousel-control-prev');
      const nextButton = document.querySelector('.product-content .carousel-control-next');

      // scrolling button show / remove
      function updateButtonVisibility() {
          const scrollLeft = carousel.scrollLeft;
          const maxScrollLeft = carousel.scrollWidth - carousel.clientWidth;  
          // Hide prev button if at start, otherwise show it
          prevButton.style.display = scrollLeft > 0 ? '' : 'none';  
          // Hide next button if at end, otherwise show it
          nextButton.style.display = scrollLeft < maxScrollLeft ? '' : 'none';
      }
      updateButtonVisibility();
      carousel.addEventListener('scroll', updateButtonVisibility);

      // scrolling button handling
      function getScrollDistance() {
          const card = carousel.querySelector('.card');
          const style = card.currentStyle || window.getComputedStyle(card);
          const cardMargin = parseFloat(style.marginRight);
          return card.offsetWidth + cardMargin;
      }  
      prevButton.addEventListener('click', function () {
          carousel.scrollBy({ left: -getScrollDistance(), behavior: 'smooth' }); // Adjust scroll amount as needed
      });
      nextButton.addEventListener('click', function () {
          console.log("scrolling: " + getScrollDistance())
          carousel.scrollBy({ left: getScrollDistance(), behavior: 'smooth' }); // Adjust scroll amount as needed
      });
  
      // swipe gesture
      let startX, moveX, isTouching = false;
      function onTouchStart(e) {
        isTouching = true;
        startX = e.touches[0].clientX;
      }
      function onTouchMove(e) {
        if (!isTouching) return;
        moveX = e.touches[0].clientX;
        let moveDistance = moveX - startX;
        carousel.scrollLeft -= moveDistance;    
        startX = moveX; // Reset startX for the next onTouchMove call
      }
      function onTouchEnd() {
        isTouching = false;
      }
      carousel.addEventListener('touchstart', onTouchStart);
      carousel.addEventListener('touchmove', onTouchMove);
      carousel.addEventListener('touchend', onTouchEnd);

      // debug stuff
      /*document.querySelectorAll('*').forEach(el => {
        if(el.offsetWidth > document.documentElement.clientWidth) {
          console.log('Overflowing element:', el);
        }
      });*/
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;
      theme.ProductBlockManager.loadImages(productRecommendationsSection);
      theme.initAnimateOnScroll();
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !window.DesignMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    var checkForVideo=setInterval(function(){
      if(is_in_DOM(document.querySelector(".video-container__video-element"))){
        document.querySelector(".video-container__play").click();
        clearInterval(checkForVideo);
      }
    }, 1000);
  });

  function is_in_DOM(container){
    if(container){
      return true;
    } else {
      return false;
    }
  }
  

  } catch(e) { console.error(e); }
})();
})();
